import {
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "design-react-kit";
import { useEffect, useState } from "react";

const ModalComponent = (props) => {
  return (
    <div>
      <Modal
      
        isOpen={props.isOpen}
        toggle={() => props.toggleModal(!props.isOpen)}
        size={"lg"}
        labelledBy={props.labelledBy}
        centered
      >
        <ModalHeader style={{ fontSize: "1.1rem" }}  id={props.labelledBy}>
          {props.header}
        </ModalHeader>
        <ModalBody>{props.body}</ModalBody>
        <ModalFooter>
          {props.buttonConfirm && (
            <Button
              color="btn btn-outline-primary"
              onClick={() => props.function()}
            >
              {props.buttonConfirm}
            </Button>
          )}
          {props.buttonDeny && (
            <Button
              color="btn btn-secondary"
              onClick={() => props.toggleModal(!props.isOpen)}
            >
              {props.buttonDeny}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </div>
  );
};
export default ModalComponent;
